export default __webpack_public_path__ + "img/vHbtBPjk.0ea95ba8.svg";